function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBrowsingHistoryRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14v-2h-6V7h-2v7h8zM19 2c6.075 0 11 4.925 11 11s-4.925 11-11 11c-1.041 0-2.045-.154-3-.425V16H8.425A10.96 10.96 0 018 13C8 6.925 12.925 2 19 2zM2 20h3v-2H2v2zM2 25h3v-2H2v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 20h7v-2H7v2zM7 25h7v-2H7v2zM2 30h3v-2H2v2zM7 30h7v-2H7v2z",
    fill: props.color
  }));
}

export default SvgIconBrowsingHistoryRexFilled;